import emailSpellChecker from "@zootools/email-spell-checker";

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const handleEmailSpellChecking = (value, $result) => {
  const suggestedEmail = emailSpellChecker.run({
    email: value,
  });
  if (suggestedEmail) {
    $result.find("button").html(suggestedEmail.full);
    $result.show();
  } else {
    $result.hide();
  }
};

const debouncedEmailSpellChecking = debounce(handleEmailSpellChecking);

const initSpellChecker = () => {
  const $inputs = $("input.email-spell-checker");

  $inputs.each(function () {
    const $input = $(this);
    const $result = $(this).parent().siblings(".email-spell-checker-result");
    const $btn = $result.find("button");

    $input.on("input", (e) =>
      debouncedEmailSpellChecking(e.target.value, $result)
    );
    $btn.on("click", () => {
      $input.val($btn.text());
      handleEmailSpellChecking($btn.text(), $result);
    });
  });
};

// Initialize the spell checker
initSpellChecker();

export default initSpellChecker;
